import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import { getUser, unregisterUser } from "../services/userService";
import { setJwt } from "../services/httpService";
import BackGroundRectangle from "../components/backgroundRect";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";


class UnregisterUserModal extends React.Component {
  state = {
    errors: {},
    showunregister: false
  };

  doSubmit = async () => {

    try {
      const jwt = localStorage.getItem("token");
      setJwt(jwt);
      await unregisterUser(this.props.id);
      toast.success("User unregistered successfully");
      if (this.props.onUpdate) {
        this.props.onUpdate(this.props.id);
      }
      // window.location = "/login";
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors: errors });
      }
    }
  };
  handleShow = () => {
    this.setState({ showunregister: true });
  };

  handleHide = () => {
    this.setState({ showunregister: false });
  };



  render() {
    return (
       <>
       <button
          onClick={this.handleShow}
          className="btn btn-outline-light"
          style={{ padding: "0", marginTop: "-5px" }}
        >
        
        <FontAwesomeIcon
          icon="trash-alt"
          size="sm"
          color="red"
        />
        </button>
        <Modal
          show={this.state.showunregister

          }
          onHide={this.handleHide}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Confirm Unregister
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            Are you sure you want to unregister? 
          </Modal.Body>

          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={this.handleHide}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger"
              onClick={() => {
                this.handleHide();
                this.doSubmit();
              }}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default UnregisterUserModal;

